__turbopack_context__.v({
  "container": "ProjectedEarnings-module-scss-module__oI3fOq__container",
  "createAccountButtonContainer": "ProjectedEarnings-module-scss-module__oI3fOq__createAccountButtonContainer",
  "divider": "ProjectedEarnings-module-scss-module__oI3fOq__divider",
  "headerContainer": "ProjectedEarnings-module-scss-module__oI3fOq__headerContainer",
  "textInfoContainer": "ProjectedEarnings-module-scss-module__oI3fOq__textInfoContainer",
  "textWithTooltip": "ProjectedEarnings-module-scss-module__oI3fOq__textWithTooltip",
});
